"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _radio_unchecked = _interopRequireDefault(require("@wisetack/assets/img/radio_unchecked.svg"));

var _radio_checked = _interopRequireDefault(require("@wisetack/assets/img/radio_checked.svg"));

var _FormRadioButtonModule = _interopRequireDefault(require("./FormRadioButton.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var FormRadioButton = function FormRadioButton(props) {
  var label = props.label,
      checked = props.checked,
      value = props.value,
      _onClick = props.onClick;
  var radio_img = checked ? _radio_checked["default"] : _radio_unchecked["default"];
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: "17px"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _FormRadioButtonModule["default"].radio
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _FormRadioButtonModule["default"].radio_img
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: radio_img,
    alt: "checked",
    onClick: function onClick() {
      return _onClick(value);
    }
  })), /*#__PURE__*/_react["default"].createElement("span", null, label)));
};

var _default = FormRadioButton;
exports["default"] = _default;